import { IconButton, Tooltip, styled } from "@mui/material";
import clsx from "clsx";
import { useNavigate } from "react-router";
import { IWithClassName } from "../../../theme/default.theme";
import { RunStatus } from "../enum/run-status";
import { IListBuilderTableDto } from "../interface/dto/list-builder-table-list.dto";
interface IOwnProps {
    listBuilder: IListBuilderTableDto;
}

const ListBuilderEdit = ({
    className,
    listBuilder,
}: IWithClassName & IOwnProps) => {
    const navigate = useNavigate();

    const navigateToDetails = () => {
        void navigate(`/list-builder/${listBuilder.listBuilderId}`);
    };

    const isButtonDisabled = listBuilder
        ? [RunStatus.Pending, RunStatus.Running].includes(
              listBuilder.lastRunStatus,
          ) && listBuilder.lastRunProgress < 100
        : true;

    return (
        <span className={className}>
            <Tooltip title="Edit this List Builder">
                <span>
                    <IconButton
                        onClick={navigateToDetails}
                        aria-label="edit"
                        disabled={isButtonDisabled}
                        className={clsx({ disabledButton: isButtonDisabled })}
                    >
                        <img src="/assets/edit.svg" alt="Edit" />
                    </IconButton>
                </span>
            </Tooltip>
        </span>
    );
};

export default styled(ListBuilderEdit)(() => ({
    ".disabledButton": {
        opacity: 0.5,
    },
}));
